<template>
<div class="chapter">
<div class="inner_page">
<p class="center1"><a id="ch00_fm02_title"></a><a id="page_3"></a>The<br/>Young Professional’s<br/>Guide to</p>
<h1 class="h1"><strong>MANAGING</strong></h1>
<p class="center2">Building, Guiding, and Motivating<br/>Your Team to Achieve<br/>Awesome Results</p>
<p class="author1">Aaron McDaniel</p>
<p class="center">author of<br/><em>The Young Professional’s Guide to the Working World</em></p>
<p class="images1"><img alt="image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm02_title.vue?4ca5c89b